import React, { useEffect, useState } from "react";
import { useWebData } from "../context/WebDataContext"; // 🔥 Changed: Import Context
import { db } from "../firebaseConfig";
import { doc, updateDoc, deleteDoc } from "firebase/firestore"; // 🔥 Changed: Removed query, collection, onSnapshot, auth
import * as XLSX from "xlsx";
import Loader from "../components/Loader";

function Leads() {
  // 🔥 Changed: Fetch data from Context
  const { leads, loading, currentUser, isMaster } = useWebData();
  
  // Derive currentSender from Context (needed for Delete button logic)
  const currentSender = currentUser ? (currentUser.displayName || currentUser.email.split('@')[0]) : "Admin";

  const [filtered, setFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("month");
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));

  // States
  const [viewData, setViewData] = useState(null);
  const [editData, setEditData] = useState(null);

  // 1. LIVE DATA (REMOVED - Now handled by Context)

  // 🔥 SUPER SEARCH LOGIC
  useEffect(() => {
    // 🔥 Changed: Use leads from context instead of 'data' state
    let result = leads;

    // Sort logic moved here since we get raw list from context
    result = [...result].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

    if (filterType === "month") result = result.filter(i => (i.createdAt || "").startsWith(selectedMonth));
    
    if (searchTerm) {
        const keywords = searchTerm.toLowerCase().split(" ").filter(w => w);
        result = result.filter(i => {
            const row = `${i.org} ${i.name} ${i.city} ${i.phone} ${i.email} ${i.product} ${i.source} ${i.status} ${i.userName}`.toLowerCase();
            return keywords.every(w => row.includes(w));
        });
    }
    setFiltered(result);
  }, [leads, searchTerm, filterType, selectedMonth]); // 🔥 Changed dependency

  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filtered.map(i => ({
        Date: formatDate(i.createdAt),
        Org: i.org, Contact: i.name, Phone: i.phone, Email: i.email, City: i.city, 
        Product: i.product, Source: i.source, Status: i.status, 
        Next_Followup: i.nextFollowup, Notes: i.notes, Added_By: i.userName
    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Leads");
    XLSX.writeFile(wb, "Leads_Master.xlsx");
  };

  const handleSaveEdit = async () => {
      if(!editData) return;
      try {
          await updateDoc(doc(db, "leads", editData.id), {
              org: editData.org, name: editData.name, phone: editData.phone, email: editData.email || "",
              city: editData.city, status: editData.status, 
              product: editData.product, source: editData.source,
          });
          alert("Lead Updated ✅");
          setEditData(null);
      } catch (error) { alert("Update Failed ❌"); }
  };

  const handleDelete = async (id) => {
      if(window.confirm("Delete lead?")) await deleteDoc(doc(db, "leads", id));
  };

  const formatDate = (iso) => {
    if(!iso) return "-";
    const date = new Date(iso);
    return isNaN(date.getTime()) ? iso : date.toLocaleDateString('en-GB');
  };

  // 🔥 HELPERS: WhatsApp, Call, Email
  const openWhatsApp = (phone) => {
      if(!phone) return;
      let cleanNum = phone.replace(/[^0-9]/g, '');
      if(cleanNum.length === 10) cleanNum = "91" + cleanNum;
      window.open(`https://web.whatsapp.com/send?phone=${cleanNum}`, '_blank');
  };
  const makeCall = (phone) => window.location.href = `tel:${phone}`;
  
  // 🔥 NEW: CLICK TO EMAIL
  const sendEmail = (email) => {
      if(!email) return alert("No email added for this lead");
      window.location.href = `mailto:${email}`;
  };

  const getRowStyle = (nextFollowup, status) => {
      if(status === 'Closed' || status === 'Lost') return {};
      const today = new Date().toISOString().split('T')[0];
      if(!nextFollowup) return {};
      if (nextFollowup < today) return { backgroundColor: '#ffebee' }; 
      if (nextFollowup === today) return { backgroundColor: '#fffde7' }; 
      return {};
  };

  return (
    <div style={{padding:"10px", fontFamily:"Arial"}}>
      <div style={headerStyle}>
        <h2 style={{margin:0, color:"#3498db", fontSize:"18px"}}>👥 Leads Master ({filtered.length})</h2>
        <div style={{display:"flex", gap:"5px", flexWrap:"wrap"}}>
            <input type="text" placeholder="🔍 Search..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} style={{...inputStyle, width:"150px"}} />
            <button onClick={downloadExcel} style={btnDownload}>📥 Excel</button>
        </div>
      </div>

      {loading ? <Loader /> : (
        <div style={{overflowX:"auto"}}>
          <table border="1" style={tableStyle}>
            <thead>
                <tr style={{backgroundColor:"#3498db", color:"white"}}>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Org Name</th>
                    <th style={thStyle}>Contact / Actions</th>
                    <th style={thStyle}>City</th>
                    <th style={thStyle}>Product</th>
                    <th style={thStyle}>Source</th>
                    <th style={thStyle}>Follow Up</th>
                    <th style={thStyle}>Status</th>
                    <th style={{...thStyle, width:"90px"}}>Actions</th>
                </tr>
            </thead>
            <tbody>
              {filtered.map(row => (
                <tr key={row.id} style={{textAlign:"center", height:"35px", ...getRowStyle(row.nextFollowup, row.status)}}>
                    <td style={tdStyle}>{formatDate(row.createdAt)}</td>
                    <td style={{...tdStyle, fontWeight:"bold", textAlign:"left"}}>{row.org}</td>
                    
                    {/* 🔥 UPDATED: Contact Column with Icons */}
                    <td style={tdStyle}>
                        <b>{row.name}</b> <br/>
                        <div style={{display:'flex', gap:'8px', justifyContent:'center', marginTop:'2px'}}>
                            <span title="Call" style={{cursor:"pointer"}} onClick={()=>makeCall(row.phone)}>📞</span>
                            <span title="WhatsApp" style={{cursor:"pointer"}} onClick={()=>openWhatsApp(row.phone)}>💬</span>
                            <span title="Email" style={{cursor:"pointer"}} onClick={()=>sendEmail(row.email)}>✉️</span>
                        </div>
                        <span style={{fontSize:"10px", color:"gray"}}>{row.phone}</span>
                    </td>
                    
                    <td style={tdStyle}>{row.city}</td>
                    <td style={tdStyle}>{row.product}</td>
                    <td style={tdStyle}>{row.source}</td>
                    
                    <td style={{...tdStyle, fontWeight: (row.nextFollowup <= new Date().toISOString().split('T')[0]) ? 'bold' : 'normal', color: (row.nextFollowup < new Date().toISOString().split('T')[0]) ? 'red' : 'inherit'}}>
                        {formatDate(row.nextFollowup) || '-'}
                    </td>
                    
                    <td style={{...tdStyle, fontWeight:"bold", color: row.status==='Hot'?'red':'#333'}}>{row.status}</td>
                    <td style={tdStyle}>
                        <div style={{display:"flex", justifyContent:"center", gap:"5px"}}>
                            <button onClick={() => setViewData(row)} style={btnIcon} title="View">👁️</button>
                            <button onClick={() => setEditData(row)} style={btnIconEdit} title="Edit">✏️</button>
                            {(isMaster || row.userName === currentSender) && (
                                <button onClick={() => handleDelete(row.id)} style={btnIconDelete} title="Delete">🗑️</button>
                            )}
                        </div>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* EDIT MODAL with Email */}
      {editData && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{color:"#e67e22", marginTop:0}}>✏️ Edit Lead</h3>
            <input type="text" value={editData.org} onChange={(e)=>setEditData({...editData, org:e.target.value})} style={modalInput} placeholder="Org Name"/>
            <div style={{display:"flex", gap:"5px"}}>
                <input type="text" value={editData.name} onChange={(e)=>setEditData({...editData, name:e.target.value})} style={modalInput} placeholder="Contact Person"/>
                <input type="text" value={editData.phone} onChange={(e)=>setEditData({...editData, phone:e.target.value})} style={modalInput} placeholder="Phone"/>
            </div>
            {/* 🔥 EMAIL INPUT ADDED */}
            <input type="email" value={editData.email || ""} onChange={(e)=>setEditData({...editData, email:e.target.value})} style={modalInput} placeholder="Email Address (Optional)"/>
            
            <div style={{display:"flex", gap:"5px"}}>
                <input type="text" value={editData.city} onChange={(e)=>setEditData({...editData, city:e.target.value})} style={modalInput} placeholder="City"/>
                <input type="text" value={editData.product} onChange={(e)=>setEditData({...editData, product:e.target.value})} style={modalInput} placeholder="Product"/>
            </div>
            <select value={editData.status} onChange={(e)=>setEditData({...editData, status:e.target.value})} style={modalInput}>
                <option value="Open">Open</option><option value="Hot">Hot 🔥</option><option value="Cold">Cold ❄️</option><option value="Closed">Closed ✅</option><option value="Lost">Lost ❌</option>
            </select>
            <div style={{marginTop:"15px", textAlign:"right"}}>
                <button onClick={()=>setEditData(null)} style={btnCancel}>Cancel</button>
                <button onClick={handleSaveEdit} style={btnSave}>Update</button>
            </div>
          </div>
        </div>
      )}
      {/* VIEW MODAL (Optional update for Email) */}
      {viewData && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3>Lead Details</h3>
             {/* ... baaki details ... */}
             <div><strong>✉️ Email:</strong> {viewData.email || "N/A"}</div>
             <button onClick={()=>setViewData(null)} style={btnClose}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

// STYLES (Same as before)
const headerStyle={backgroundColor:"#f8f9fa", padding:"8px", borderRadius:"8px", marginBottom:"10px", display:"flex", justifyContent:"space-between", alignItems:"center"};
const tableStyle={width:"100%", borderCollapse:"collapse", fontSize:"11.5px", whiteSpace:"nowrap"};
const thStyle={padding:"8px 4px", border:"1px solid #ddd", backgroundColor:"#3498db", color:"white", textAlign:"center"};
const tdStyle={padding:"4px", border:"1px solid #ddd", verticalAlign:"middle"};
const inputStyle={padding:"5px", border:"1px solid #ccc", borderRadius:"4px", fontSize:"12px"};
const btnDownload={backgroundColor:"#27ae60", color:"white", border:"none", padding:"5px 10px", borderRadius:"4px", cursor:"pointer", fontSize:"12px"};
const btnIcon={backgroundColor:"#3498db", color:"white", border:"none", padding:"4px 6px", borderRadius:"3px", cursor:"pointer", fontSize:"12px"};
const btnIconEdit={backgroundColor:"#f39c12", color:"white", border:"none", padding:"4px 6px", borderRadius:"3px", cursor:"pointer", fontSize:"12px"};
const btnIconDelete={backgroundColor:"#e74c3c", color:"white", border:"none", padding:"4px 6px", borderRadius:"3px", cursor:"pointer", fontSize:"12px"};
const modalOverlay={position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.5)", display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000};
const modalContent={background:"white", padding:"20px", borderRadius:"8px", width:"380px", boxShadow:"0 5px 15px rgba(0,0,0,0.3)"};
const modalInput={width:"100%", padding:"8px", margin:"5px 0", borderRadius:"4px", border:"1px solid #ccc", boxSizing:"border-box", fontSize:"13px"};
const btnSave={backgroundColor:"#27ae60", color:"white", border:"none", padding:"8px 15px", borderRadius:"4px", cursor:"pointer", marginLeft:"5px"};
const btnCancel={backgroundColor:"#95a5a6", color:"white", border:"none", padding:"8px 15px", borderRadius:"4px", cursor:"pointer"};
const btnClose={marginTop:"15px", backgroundColor:"#333", color:"white", border:"none", padding:"8px", borderRadius:"4px", width:"100%", cursor:"pointer"};

export default Leads;